import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import Switch from '@mui/material/Switch';
import { Button } from '@/components/button';
import { useLocalization } from '@/localization';
import { ModalContainer, ModalFooter, ModalIntro, ModalOverlay, ModalTitle, SectionDescription, SectionRow, SectionText, SectionTitle, } from './cookie-consent-modal.styles';
function CookieConsentModal({ onSave, onClose, initialCategories }) {
    var _a;
    const { formatMessage: t } = useLocalization();
    const [analyticsEnabled, setAnalyticsEnabled] = useState((_a = initialCategories === null || initialCategories === void 0 ? void 0 : initialCategories.analytics) !== null && _a !== void 0 ? _a : false);
    const handleSave = () => {
        onSave({ analytics: analyticsEnabled });
        onClose();
    };
    return ReactDOM.createPortal(<ModalOverlay data-testid="cookie-consent-modal">
      <ModalContainer>
        <ModalTitle>
          {t({ key: 'COOKIE_CONSENT_MODAL_TITLE' })}
        </ModalTitle>

        <ModalIntro>
          {t({ key: 'COOKIE_CONSENT_MODAL_INTRO' })}
        </ModalIntro>

        <SectionRow>
          <SectionText>
            <SectionTitle>
              {t({ key: 'COOKIE_CONSENT_STRICTLY_NECESSARY_TITLE' })}
            </SectionTitle>
            <SectionDescription>
              {t({ key: 'COOKIE_CONSENT_STRICTLY_NECESSARY_DESCRIPTION' })}
            </SectionDescription>
          </SectionText>
          <Switch checked disabled slotProps={{ input: { 'data-testid': 'cookie-consent-strictly-necessary-toggle', 'aria-label': t({ key: 'COOKIE_CONSENT_STRICTLY_NECESSARY_ARIA' }) } }}/>
        </SectionRow>

        <SectionRow>
          <SectionText>
            <SectionTitle>
              {t({ key: 'COOKIE_CONSENT_ANALYTICS_TITLE' })}
            </SectionTitle>
            <SectionDescription>
              {t({ key: 'COOKIE_CONSENT_ANALYTICS_DESCRIPTION' })}
            </SectionDescription>
          </SectionText>
          <Switch checked={analyticsEnabled} onChange={(e) => setAnalyticsEnabled(e.target.checked)} slotProps={{ input: { 'data-testid': 'cookie-consent-analytics-toggle', 'aria-label': t({ key: 'COOKIE_CONSENT_ANALYTICS_ARIA' }) } }}/>
        </SectionRow>

        <ModalFooter>
          <Button rounded data-testid="cookie-consent-cancel-btn" onClick={onClose}>
            {t({ key: 'COOKIE_CONSENT_CANCEL' })}
          </Button>

          <Button rounded variant="contained" color="primary" data-testid="cookie-consent-save-btn" onClick={handleSave}>
            {t({ key: 'COOKIE_CONSENT_SAVE_PREFERENCES' })}
          </Button>
        </ModalFooter>
      </ModalContainer>
    </ModalOverlay>, document.body);
}
export { CookieConsentModal };
